import { ovl } from ".."
import { resolvePath } from "../global/globals"
import { SYSBaseElement } from "../library/sysbaseelement"
import { actionTracking } from "./proxyhandler"

import { reactors } from "./reactor"
export let callbacks = new WeakMap()
export let paths = new Map()
// export let activeCallback: SYSBaseElement | undefined

// let noTracking: boolean = false

let activeComponents = []
export let _RenderTracking = {
  currentComponent: undefined,
  pauseTracking: false,
  totalCompRendered: 0,
}

export const startTrack = (cb: SYSBaseElement) => {
  //console.log("startTrack ", cb)
  _RenderTracking.currentComponent = cb
  _RenderTracking.pauseTracking = false
}

export const stopTrack = () => {
  _RenderTracking.pauseTracking = true
  _RenderTracking.currentComponent = undefined
}

export const pauseTracking = () => {
  _RenderTracking.pauseTracking = true
}

export const resumeTracking = () => {
  _RenderTracking.pauseTracking = false
}

export const disposeTrack = (cb: SYSBaseElement) => {
  // get all paths and remove from there as well

  let pathsSet = callbacks.get(cb)
  if (pathsSet) {
    pathsSet.forEach((path: string) => {
      pathsSet.delete(path)
      let pathsCallbackSet = paths.get(path)
      pathsCallbackSet.delete(cb)
      if (pathsCallbackSet.size === 0) {
        paths.delete(path)
      }
    })
  }
  callbacks.delete(cb)
}

export const logTrackingList = () => {
  console.log("tracking information")
  console.log("components:")
  console.log(callbacks)
  console.log("paths:")
  console.log(paths)
  console.log("reactors:")
  console.log(reactors)
}

export const testReactorsPaths = () => {
  for (const key of reactors.keys()) {
    console.log(key)
    let res = resolvePath(ovl.getState(), key)
    if (res === undefined) {
      console.log("%cUndefined", "color:red")
    } else {
      console.log("%cOk", "color:green", "Current Value:", res)
    }
  }
}

// export const pauseTracking = () => {
//   noTracking = true
// }

// export const resumeTracking = () => {
//   noTracking = false
// }

export const isTracking = () => {
  return (
    _RenderTracking.currentComponent !== undefined &&
    _RenderTracking.pauseTracking === false /*&&
    actionTracking.actionRunning === false */
  ) //!noTracking && activeCallback !== undefined
}

export const addTrackedPath = (path: string) => {
  let currentComp = _RenderTracking.currentComponent
  // if (
  //   path.indexOf("CERGlobalGAP_OvlSep_ForceRenew_OvlSep_Multi") > -1 &&
  //   path.indexOf("lockedTableKeys") > -1
  // ) {
  //   console.log(currentComp)
  // }

  // if (
  //   path.indexOf(
  //     "ACTActivities6_OvlSep_ExternalUseSendNotification_OvlSep_Multi"
  //   ) > -1 &&
  //   path.indexOf("lockedTableKeys") > -1
  // ) {
  //   console.log(currentComp)
  // }

  if (currentComp !== undefined) {
    let compPaths = callbacks.get(currentComp)
    if (compPaths === undefined) {
      compPaths = new Set()
      callbacks.set(currentComp, compPaths)
    }
    compPaths.add(path)
    if (!paths.has(path)) {
      paths.set(path, new Set())
    }
    paths.get(path).add(currentComp)
  }
}
